// 帳簿（事業）の一覧と表示名。**ここが帳簿一覧の唯一の正本**。
//
// なぜ lib/db.ts から切り出したか（2026-07-31）:
//   BookSwitcher.tsx は "use client" のクライアントコンポーネントで、
//   帳簿一覧を lib/db.ts から import していた。lib/db.ts は Prisma と
//   better-sqlite3 を抱えているため、定数を1つ取り込むだけで DB 一式が
//   ブラウザ用バンドルに引きずり込まれ、next build が失敗し、
//   dev でも全ページが HTTP 500 になっていた。
//   定数はサーバ・クライアントの両方から使うので、
//   Node 依存を一切持たないこのファイルに置く。
//
// ⚠ このファイルに import を足さないこと。
//    Node 専用モジュール（node:fs / prisma / better-sqlite3 等）を
//    ここに持ち込むと、同じ事故が再発する。

export const BOOKS = ["hojin", "kojin_takahiro", "kojin_misato"] as const;
export type Book = (typeof BOOKS)[number];

export const BOOK_LABEL: Record<Book, string> = {
  hojin: "法人",
  kojin_takahiro: "個人 浅田章弘",
  kojin_misato: "個人 浅田美里",
};
